import { Carousel } from 'antd';
import heroImage1 from "../../../assets/img/homepage/heroImages/Hero section 1.png";
import heroImage2 from "../../../assets/img/homepage/heroImages/Hero section 2.png";
import heroImage3 from "../../../assets/img/homepage/heroImages/Hero section 11.png";
import heroImageMobile1 from "../../../assets/img/homepage/heroImages/HeroMobile1.png";
import heroImageMobile2 from "../../../assets/img/homepage/heroImages/HeroMobile2.png";
import heroImageMobile3 from "../../../assets/img/homepage/heroImages/HeroMobile3.png";
import heroImageMobile1P from "../../../assets/img/homepage/heroImages/HeroMobile1P.png";
import { useMediaQuery } from 'react-responsive';
import ActionButtons from './ActionButtons';

const HeroSection = ({ isTabletOrMobile }) => {
    const isPortrait = useMediaQuery({ orientation: 'portrait' });

    const overlayStyle = {
        position: "absolute",
        bottom: !isTabletOrMobile && 200,
        color: "white",
        padding: "40px 30px 30px",
        transform: "translateY(0)",
        transition: "transform 0.3s ease",
        left: !isTabletOrMobile && "120px"
    };

    const overlayStyle2 = {
        position: "absolute",
        top: "20%",
        left: "50%",
        textAlign: "center",
        width: "100%",
        transform: "translate(-50%, -50%)",
        transition: "transform 0.3s ease",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    };

    const overlayStyle3 = {
        position: 'absolute',
        bottom: 40,
        right: 180,
        color: 'white',
        transition: 'transform 0.3s ease',
        textAlign: "right",
    }

    const contentStyle = {
        position: 'relative',
        height: '800px',
        overflow: 'hidden',
    };

    const imageStyle = {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        display: 'block',
    };

    const carouselStyle = {
        maxWidth: '100%',
        margin: '0 auto',
        paddingTop: '20px',
    };

    return (
        <div style={carouselStyle}>
            <Carousel autoplay
                dots={{ className: 'custom-dots' }}
                autoplaySpeed={4000}
                speed={800}
                effect="fade" >
                <div key={1}>
                    <div style={contentStyle}>
                        {isTabletOrMobile ?
                            <img alt="Hero" src={isPortrait ? heroImageMobile1P : heroImageMobile1} style={imageStyle} />
                            : <img alt="Hero" src={heroImage1} style={imageStyle} />
                        }

                    </div>
                    <div style={overlayStyle}>
                        <p className='hero-text-line1-header'>Cutting Edge Lab equipment for </p>
                        <p className='hero-text-line2-header'>precision & performance</p>
                        <p className='hero-text-description'>Welcome to CENVANCE INNOVATIONS, your trusted source for
                            high-quality laboratory equipment designed for precision,
                            efficiency, and reliability. We offer a wide range of industry-
                            leading tools, from microscopes to centrifuges, ensuring that
                            researchers, scientists, and professionals have access to the best technology.</p>
                        <ActionButtons learnMoreVariant="white" />
                    </div>
                </div>

                <div key={2}>
                    <div style={contentStyle}>
                        <img alt="Hero" src={isTabletOrMobile ? heroImageMobile2 : heroImage2} style={imageStyle} />
                    </div>
                    <div style={overlayStyle2}>
                        <h1 className='hero2-text-line1-header'>“Cenvance — Innovating Healthcare, One Instrument at a Time.”</h1>
                        <h2 className='hero2-text-line2-header'>Pioneering solutions for modern medical challenges.</h2>
                        <ActionButtons />
                    </div>
                </div>

                <div key={3}>
                    <div style={contentStyle}>
                        <img alt="Hero" src={isTabletOrMobile ? heroImageMobile3 : heroImage3} style={imageStyle} />
                    </div>
                    <div style={overlayStyle3}>
                        <h2 className='hero3-text-line1-header'>The Backbone of Every Bold Experiment.<br />
                            Because Reliable Results Start with<br /> Reliable Supplies.</h2>
                        <ActionButtons learnMoreVariant="white" style={{ float: "right" }} />
                    </div>
                </div>

            </Carousel >
        </div>
    );
}

export default HeroSection;